module.exports = __webpack_public_path__ + "static/media/jardines04.ce9eb49d.jpg";